import React from "react";
import {Icon, LinkList, LinkListItem} from "peggirkit";
import {ArrowTopRightOnSquareIcon, HomeIcon} from "@heroicons/react/24/outline";
import router from "@/routing/Router";
import {useIntl} from "react-intl";

const ErrorLinks = () => {
    const intl = useIntl();

    return (
        <LinkList>
            <LinkListItem
                icon={<Icon icon={HomeIcon}/>}
                title={intl.formatMessage({id: "dashboard"})}
                description={intl.formatMessage({id: "manageFromDashboard"})}
                action={{to: router.index.absolutePath()}}
            />
            <LinkListItem
                icon={<Icon icon={ArrowTopRightOnSquareIcon}/>}
                title={"Eataliano.nl"}
                description={intl.formatMessage({id: "toEatalianoHome"})}
                action={{href: "https://eataliano.nl/", rel: "nofollow"}}
            />
            <LinkListItem
                icon={<Icon icon={ArrowTopRightOnSquareIcon}/>}
                title={intl.formatMessage({id: "documentation"})}
                description={intl.formatMessage({id: "goToDocumentation"})}
                action={{href: "https://eataliano.docs.peggir.com/", rel: "nofollow"}}
            />
        </LinkList>
    );
};

export default ErrorLinks;